import { render, staticRenderFns } from "./IgCheckoutSuccess.vue?vue&type=template&id=2e93258a&scoped=true&"
import script from "./IgCheckoutSuccess.vue?vue&type=script&lang=js&"
export * from "./IgCheckoutSuccess.vue?vue&type=script&lang=js&"
import style0 from "./IgCheckoutSuccess.vue?vue&type=style&index=0&id=2e93258a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93258a",
  null
  
)

export default component.exports